import React, { useMemo } from "react";
import EntityEmptyState from "../../components/EntityEmptyState";
import { EMPTY_MESSAGES } from "../../constants/emptyStateMessages";
import "../../starek.css";

function FavReportsCardView({
    items,
    selectedRows,
    onSelectedRowsChange,
    filterText,
    onRun,
    isDeleting,
    onAdd,
}) {
    const isReportSelected = (reportId) => {
        return selectedRows.some((row) => row.id === reportId);
    };

    const handleCheckboxChange = (report) => {
        let newSelectedRows;
        if (isReportSelected(report.id)) {
            newSelectedRows = selectedRows.filter(
                (row) => row.id !== report.id
            );
        } else {
            newSelectedRows = [...selectedRows, report];
        }
        if (onSelectedRowsChange) {
            onSelectedRowsChange({ selectedRows: newSelectedRows });
        }
    };

    const filteredItems = useMemo(() => {
        const q = filterText?.trim().toLowerCase();
        if (!q) return items;
        return items.filter(
            (item) =>
                item.name?.toLowerCase().includes(q) ||
                item.description?.toLowerCase().includes(q)
        );
    }, [items, filterText]);

    if (filteredItems.length === 0) {
        return (
            <EntityEmptyState
                icon="fa-star"
                entityName="Snapshot"
                messages={EMPTY_MESSAGES.favReports}
                isFiltered={!!filterText?.trim()}
                onAdd={onAdd}
                addLabel="Browse Quick View"
            />
        );
    }

    return (
        <div className="row g-3">
            {filteredItems.map((report) => (
                <div key={report.id} className="col-lg-3 col-md-4 col-sm-6">
                    <div
                        className={`card h-100 shadow-sm ${
                            isReportSelected(report.id)
                                ? "border-primary border-2"
                                : ""
                        }`}
                        style={{ cursor: "pointer" }}
                    >
                        <div className="card-header bg-primary text-white">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center flex-grow-1">
                                    <div className="form-check mb-0 me-2">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={isReportSelected(
                                                report.id
                                            )}
                                            onChange={() =>
                                                handleCheckboxChange(report)
                                            }
                                            aria-label={`Select ${report.name}`}
                                        />
                                    </div>
                                    <h5
                                        className="card-title mb-0 text-truncate"
                                        title={report.name}
                                    >
                                        {report.name}
                                    </h5>
                                </div>
                                <button
                                    className="btn btn-sm btn-light d-flex align-items-center justify-content-center ms-2"
                                    style={{
                                        width: "32px",
                                        height: "32px",
                                        padding: 0,
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onRun(report);
                                    }}
                                    title="Run Report"
                                    disabled={isDeleting}
                                >
                                    <i
                                        className="fa fa-play"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </button>
                            </div>
                        </div>
                        <div className="card-body d-flex flex-column">
                            <p
                                className="text-muted mb-3 flex-grow-1"
                                style={{ fontSize: "0.875rem" }}
                            >
                                {report.description || "No description"}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default FavReportsCardView;
